// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headingsFontConfig } from "@flip/XDL/PreStyle/typography";
import { color } from "@flip/XDL/Utilities";
import { imageStyles } from "@insite/content-library/Widgets/BrandDetails/BrandDetailsImage";
import { StyledTypography } from "@insite/mobius/Link";
import { css } from "styled-components";

imageStyles.container = {
    gap: 0
}

imageStyles.linksContainer = {
    gap: 0,
    css: css`
        padding: 0;
    `,
};

imageStyles.productLink = {
    css: css`
        background-color: ${color("secondary")};
        padding: 12px 32px;
        border-radius: 8px;

        &:hover {
            background-color: ${color("common.ui13")};
            text-decoration: none;
            ${StyledTypography} {
                color: ${color("common.ui8")};
                text-decoration: none;
            }
        }

        ${StyledTypography} {
            color: ${color("common.ui8")};
            font-size: 14px;
            line-height: 16px;
            font-family: ${headingsFontConfig.fontFamily};
            font-weight: ${headingsFontConfig.weight.bold};
        }
    `,
};
